import React from 'react'
import SearchContainer from './SearchContainer'
import MapControlsContainer from './MapControlsContainer'

export default ({ searchOpen }) => {
	return searchOpen
		? <SearchContainer />
		: <MapControlsContainer />
}


// WEBPACK FOOTER //
// ./src/components/MapMenu/MapMenu.js